module.exports = __webpack_public_path__ + "static/media/explosive.a3fe13cc.png";